import React from 'react';

var Timer = function Timer() {
  return /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": true,
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    role: "img",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21839 3.65517V2C12.5321 2 15.2184 4.68629 15.2184 8C15.2184 11.3137 12.5321 14 9.21839 14C6.55469 14 4.29641 12.2642 3.51294 9.86207",
    stroke: "#666666",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 6.5H4.75M3.25 5V8",
    stroke: "#666666",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41501 3.91108L9.81107 7.20749C10.3272 7.59449 10.3647 8.35519 9.88923 8.79114V8.79114C9.41374 9.22708 8.65915 9.12379 8.3183 8.57611L5.41501 3.91108Z",
    stroke: "#666666",
    strokeWidth: "1.25",
    strokeLinejoin: "round"
  }));
};
Timer.displayName = "Timer";

export { Timer as default };
